import Backbone from 'backbone';
import AgentDevices from 'collections/device/AgentDevices';

const globalAgentDevices = new AgentDevices();

export default globalAgentDevices;
